import * as React from "react"
import Svg, {Path} from "react-native-svg"

export function DialogHeaderBack(props:any) {
    return (
        <Svg
            width={315}
            height={48}
            viewBox="0 0 315 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props} >
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M315 36.013C277.214 43.347 220.899 48 158 48 94.543 48 37.788 43.264 0 35.818V0h315v36.013z"
                fill={props.color}
            />
        </Svg>
    )
}